import { render } from "./SubjectForm.vue?vue&type=template&id=2501a4fa"
import script from "./SubjectForm.vue?vue&type=script&lang=js"
export * from "./SubjectForm.vue?vue&type=script&lang=js"

import "./SubjectForm.vue?vue&type=style&index=0&id=2501a4fa&lang=less"

import exportComponent from "D:\\cwzl\\four-cw-net\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__